import TempBillingCostRatesList from "../../components/temp-billing-cost-rates";

// The People 2.0 cost-rate periods behind "Owed to RealREPP" on the temp-billing
// reconciliation page. Executive only (route roles + server guard).
const TempBillingCostRates = () => <TempBillingCostRatesList />

export default TempBillingCostRates;
